/* Collection picker: filters and sticky bar visibility (add to cart is handled by .collection-atc in custom.js) */
(function () {
  'use strict';

  var SELECTOR = '[data-collection-picker]';

  function Picker(root) {
    if (root.__cpReady) return;
    root.__cpReady = true;

    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cp-tab]'));
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-cp-group]'));
    this.keys = this.tabs.map(function (t) { return t.getAttribute('data-cp-tab'); });
    this.designMode = !!(window.Shopify && window.Shopify.designMode);

    if (!this.tabs.length) return;

    /* filter-only section: tabs scroll to an element on the page, no groups to switch */
    if (root.hasAttribute('data-cp-scroll-mode')) {
      this.dock();
      this.scrollTabs();
      return;
    }

    var hash = window.location.hash.replace('#', '');
    var start = this.keys.indexOf(hash) > -1 ? hash : root.getAttribute('data-default-tab');
    this.activate(start || this.keys[0], { hash: false, scroll: false });

    this.bind();
    this.observe();
    this.dock();
    this.variants();
  }

  /* each tab shows only its own group ("all" has its own combined group) */
  Picker.prototype.activate = function (key, opts) {
    opts = opts || {};
    if (this.keys.indexOf(key) === -1) return;

    this.tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-cp-tab') === key;
      tab.classList.toggle('collection-picker__filter--active', on);
      tab.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var firstVisible = null;
    this.groups.forEach(function (group) {
      var on = group.getAttribute('data-cp-group') === key;
      group.hidden = !on;
      if (on && !firstVisible) firstVisible = group;
    });

    if (opts.hash !== false && !this.designMode && window.history && history.replaceState) {
      history.replaceState(null, '', '#' + key);
    }

    if (opts.scroll !== false && firstVisible && firstVisible.getBoundingClientRect().top < 0) {
      firstVisible.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  Picker.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.activate(tab.getAttribute('data-cp-tab'));
      });
    });

  };

  /* Hide the fixed mobile bar while the section is out of view */
  Picker.prototype.observe = function () {
    var root = this.root;
    if (!('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(function (entries) {
      root.classList.toggle('collection-picker--out', !entries[0].isIntersecting);
    }, { threshold: 0 });
    this.io.observe(root);
  };

  /* Desktop: dock the bar to the bottom only after its natural position has scrolled out of view */
  Picker.prototype.dock = function () {
    var root = this.root;
    var nav = root.querySelector('.collection-picker__filters');
    if (!nav || root.classList.contains('collection-picker--static-desktop')) return;
    var mq = window.matchMedia('(min-width: 768px)');
    var spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    nav.parentNode.insertBefore(spacer, nav);
    var stuck = false;
    var ticking = false;

    function update() {
      ticking = false;
      var h = stuck ? parseFloat(spacer.style.height) || 0 : nav.offsetHeight;
      var next = mq.matches && spacer.getBoundingClientRect().top < -h;
      if (next === stuck) return;
      stuck = next;
      spacer.style.height = stuck ? h + 'px' : '';
      root.classList.toggle('collection-picker--stuck', stuck);
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  };

  /* Filter-only mode: scroll to the target of a tab and highlight the tab whose target is in view */
  Picker.prototype.scrollTabs = function () {
    var tabs = this.tabs;

    function findTarget(tab) {
      var sel = tab.getAttribute('data-cp-target');
      var handle = tab.getAttribute('data-cp-product');
      var el = null;
      if (sel) {
        try { el = document.getElementById(sel) || document.querySelector(sel); } catch (e) { el = null; }
      }
      var pid = tab.getAttribute('data-cp-product-id');
      if (!el && pid) {
        /* same lookup as the old product tabs: the section holding the product form (product page) */
        var form = document.getElementById('product_form_' + pid);
        el = form ? form.closest('section') || form : document.querySelector('[data-handle="' + pid + '"]');
      }
      if (!el && handle) {
        el = document.querySelector('[data-handle="' + handle + '"]');
        if (!el) {
          var link = document.querySelector('a[href*="/products/' + handle + '"]');
          if (link) el = link.closest('.collection-picker__card, .ProductItem, .Grid__Cell') || link;
        }
      }
      return el;
    }

    function offset() {
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var sticky = parseInt(getComputedStyle(document.body).getPropertyValue('--use-sticky-header'), 10) || 0;
      return header * sticky + 10;
    }

    function setActive(active) {
      tabs.forEach(function (tab) {
        var on = tab === active;
        tab.classList.toggle('collection-picker__filter--active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* toggle mode: show only the clicked tab's target and hide the rest, no scrolling */
    if (this.root.hasAttribute('data-cp-toggle-mode')) {
var showOnly = function (active) {
    setActive(active);
    var key = active.getAttribute('data-cp-key');
    if (key) {
      var items = document.querySelectorAll('[data-cp-tabs]');
      Array.prototype.forEach.call(items, function (item) {
        var list = item.getAttribute('data-cp-tabs').split(',').map(function (s) { return s.trim(); });
        var show = key === 'all' || list.indexOf(key) > -1;
        var wrap = item.closest('.shopify-section') || item;
        wrap.classList.toggle('collection-picker__target-hidden', !show);
      });
      return;
    }
    var shown = findTarget(active);
    tabs.forEach(function (tab) {
      var el = findTarget(tab);
      if (!el) return;
      var wrap = el.closest('.shopify-section') || el;
      var wrapShown = shown && (shown.closest('.shopify-section') || shown);
      wrap.classList.toggle('collection-picker__target-hidden', wrap !== wrapShown);
    });
  };

  // Initial state
  showOnly(tabs[0]);

  // Click handlers 
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      showOnly(tab);
    });
  });

  return;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var el = findTarget(tab);
        if (!el) return;
        setActive(tab);
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - offset(), behavior: 'smooth' });
      });
    });

    var ticking = false;
    function spy() {
      ticking = false;
      var line = offset() + 40;
      var current = tabs[0];
      tabs.forEach(function (tab) {
        var el = findTarget(tab);
        if (el && el.getBoundingClientRect().top <= line) current = tab;
      });
      setActive(current);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(spy); }
    }, { passive: true });
    spy();
  };

  /* Variant buttons: update price, image and add to cart variant id of their own card */
  Picker.prototype.variants = function () {
    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cp-variant]');
      if (!btn) return;
      var card = btn.closest('[data-cp-card]');
      if (!card) return;

      Array.prototype.forEach.call(card.querySelectorAll('[data-cp-variant]'), function (b) {
        var on = b === btn;
        b.classList.toggle('collection-picker__variant--active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var id = btn.getAttribute('data-cp-variant');
      var available = btn.getAttribute('data-available') === 'true';

      var list = card.querySelector('.ProductItem__PriceList');
      if (list) {
        var price = btn.getAttribute('data-price');
        var compare = btn.getAttribute('data-compare');
        list.innerHTML = compare
          ? '<span class="ProductItem__Price Price Price--highlight">' + price + '</span>' +
            '<span class="ProductItem__Price Price Price--compareAt">' + compare + '</span>'
          : '<span class="ProductItem__Price Price">' + price + '</span>';
      }

      var src = btn.getAttribute('data-img');
      var img = card.querySelector('.collection-picker__media img');
      if (src && img) {
        img.removeAttribute('srcset');
        img.src = src;
        var source = card.querySelector('.collection-picker__media source');
        if (source) source.parentNode.removeChild(source);
      }

      var atc = card.querySelector('.collection-atc');
      if (atc) {
        atc.setAttribute('data-var-id', id);
        atc.disabled = !available;
        atc.classList.toggle('Button--primary', available);
        atc.classList.toggle('Button--secondary', !available);
        atc.innerHTML = available
          ? '<span data-var-id="' + id + '">' + card.getAttribute('data-cta-label') + '</span>'
          : card.getAttribute('data-sold-out-label');
      }
    });
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, function (node) { new Picker(node); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target.matches && e.target.matches('[data-cp-tab]')) e.target.click();
  });
})();